import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { OrganizationMember } from '@/types/user';

type UpdateMemberNameBody =
  | {
      memberType: 'api';
      name: string;
    }
  | {
      memberType: 'regular';
      firstName: string;
      lastName: string;
    };

type UpdateMemberNameInput = {
  memberId: string;
} & UpdateMemberNameBody;

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateMemberNameInput }
): Promise<OrganizationMember> => {
  const { memberId, ...body } = arg;
  return await denApi.patch<OrganizationMember, typeof body>(
    `admin/organization/members/${memberId}/name`,
    body
  );
};

export function useUpdateMemberName(
  swrOptions?: SWRMutationConfiguration<
    OrganizationMember,
    Error,
    string,
    UpdateMemberNameInput
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    OrganizationMember,
    Error,
    string,
    UpdateMemberNameInput
  >('admin/organization/update-member-name', fetcher, swrOptions);

  return { updateMemberName: trigger, isLoading: isMutating, error };
}
